export const SET_LOADING_DATA = '@configuration/SET_LOADING_DATA';
export const SET_LOADING_SEND = '@configuration/SET_LOADING_SEND';

export const GET_REQUEST = '@configuration/GET_REQUEST';
export const GET_SUCCESS = '@configuration/GET_SUCCESS';

export const RELOAD_REQUEST = '@configuration/RELOAD_REQUEST';
export const RELOAD_SUCCESS = '@configuration/RELOAD_SUCCESS';

export const SAVE_REQUEST = '@configuration/SAVE_REQUEST';
export const SAVE_SUCCESS = '@configuration/SAVE_SUCCESS';
